<script>
import { Bar, mixins } from "vue-chartjs";

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],

  props: {
    dark: {
      type: Boolean,
      require: false,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  methods: {
    updateChart() {
      this.renderChart(this.chartData, this.options);
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.updateChart();
  },
  watch: {
    dark: function () {
      this._data._chart.destroy();

      this.updateChart();
    },
  },
};
</script>

